import { useQuery } from "@tanstack/react-query";
import { summaryService } from "./summaryService";

export function useChatSummary(
  session_id: string,
  language: string,
  open: boolean = false
) {
  return useQuery({
    queryKey: ["chatbot", "summary", session_id, language],
    queryFn: async () => {
      const response = await summaryService.generateSummary(
        session_id,
        language
      );
      return {
        outputs: [
          {
            outputs: [
              {
                outputs: {
                  text: {
                    message: response.summary
                  }
                }
              }
            ]
          }
        ]
      };
    },
    enabled: session_id.length > 0 && open,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
    retry: 0
  });
}
